var _defs, _rect, _circle, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 1024,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ringGrad",
    x1: 56,
    y1: 56,
    x2: 456,
    y2: 456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#9B8CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#FF5EA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1BE4FF"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "gradientTransform",
    type: "rotate",
    from: "0 256 256",
    to: "360 256 256",
    dur: "6s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ringGlow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 0,
    stdDeviation: 6,
    floodColor: "#9B8CFF",
    floodOpacity: 0.35
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stdDeviation",
    values: "4;6;4",
    dur: "2s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "textShadow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 1,
    stdDeviation: 1.5,
    floodColor: "#000000",
    floodOpacity: 0.35
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 200,
    fill: "none",
    stroke: "url(#ringGrad)",
    strokeWidth: 18,
    filter: "url(#ringGlow)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 256,
    y: 264,
    textAnchor: "middle",
    dominantBaseline: "central",
    fontFamily: "Georgia, 'Times New Roman', Times, serif",
    fontSize: 190,
    fontWeight: 600,
    fill: "#ECECF6",
    filter: "url(#textShadow)",
    letterSpacing: -6
  }, "NA")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.29905cd3320e31966e3abef99a63f62b.svg";
export { ForwardRef as ReactComponent };